module.exports = __webpack_public_path__ + "static/media/perks.020e29f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/perks.png
// module id = 424
// module chunks = 0